import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { AmountInput } from '@components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';

const IsAmount = () => {
    const [isMoney, setIsMoney] = useState(false);
    const [isRate, setIsRate] = useState(false);
    const [showRate, setShowRate] = useState(false);
    const [show, setShow] = useState(false);
    const {
        TrialBalanceStore: {
            getQryColCal,
            collateralUIs,
            amount,
            mRate,
            updateData,
            reset,
        },
        AuthStore: { maintenanceRatio, borrowingAmount },
    } = useStore();
    useEffect(() => {
        let timeout;
        if (show) {
            timeout = setTimeout(() => setShow(false), 4000);
        }
        return () => clearTimeout(timeout);
    }, [show]);
    useEffect(() => {
        getQryColCal();
        return () => {
            updateData('amount', '');
            updateData('mRate', '');
        };
    }, []);

    let eRate = 0;
    const sumVal = collateralUIs.reduce(
        (preVal, curVal) => preVal + curVal.marketVal,
        0
    );
    eRate = sumVal / (borrowingAmount - amount);
    let money = 0;
    if (parseFloat(mRate) > maintenanceRatio) {
        money = borrowingAmount - Math.round(sumVal / mRate) * 100;
    } else if (parseInt(mRate) === 0) {
        money = borrowingAmount;
    } else {
        money = 0;
    }

    return (
        <div>
            <div className="formbox row g-4 mb-5 mt-3">
                <div className="col-12">
                    <label
                        className="form-label"
                        onMouseOver={() => setShow(true)}
                        onMouseLeave={() => setShow(false)}
                    >
                        現金還款金額
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>最小單位為仟元</Tooltip>}
                            trigger="click"
                            show={show}
                        >
                            <i className="icon_point bi-exclamation-circle"></i>
                        </OverlayTrigger>
                    </label>
                    <li
                        className={`${
                            amount ? 'red-num position-relative' : ''
                        }`}
                    >
                        {amount ? (
                            <span className="fw-bolder position-absolute">
                                $
                            </span>
                        ) : (
                            ''
                        )}
                        <AmountInput
                            type="tel"
                            className={`form-control ${
                                amount ? 'in-focs fw-bolder' : ''
                            } `}
                            value={amount}
                            onChange={e => {
                                setIsMoney(true);
                                setIsRate(false);
                                setShowRate(false);
                                updateData('mRate', '');
                                let finalAmount = e.target.value;
                                if (
                                    parseInt(removeNonNumeric(finalAmount)) >
                                    borrowingAmount
                                ) {
                                    finalAmount = borrowingAmount;
                                }
                                updateData(
                                    'amount',
                                    removeNonNumeric(finalAmount)
                                );
                            }}
                            onBlur={e => {
                                let finalAmount = e.target.value;
                                if (
                                    parseInt(removeNonNumeric(finalAmount)) <
                                    1000
                                ) {
                                    finalAmount = 1000;
                                }
                                updateData(
                                    'amount',
                                    removeNonNumeric(finalAmount)
                                );
                                setShow(true);
                            }}
                            placeholder={`${amount ? '' : '請輸入金額'}`}
                        />
                    </li>
                </div>
                <div className="col-12">
                    <label className="form-label">
                        目標維持率
                        {/* <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>值須大於維持率</Tooltip>}
                        >
                            <i className="icon_point bi-exclamation-circle"></i>
                        </OverlayTrigger> */}
                    </label>
                    <li
                        id="ratio1"
                        className={`${
                            mRate
                                ? 'ratio-num text-orange position-relative'
                                : ''
                        }`}
                    >
                        {mRate ? (
                            <span className="fw-bolder position-absolute">
                                %
                            </span>
                        ) : (
                            ''
                        )}
                        <input
                            type="text"
                            className={`form-control ${
                                mRate ? 'in-focs fw-bolder' : ''
                            } `}
                            maxLength={6}
                            value={mRate}
                            // pattern="^[1-9]{3}\.[0-9]{2}$|^[0][1-9]{2}\.[0-9]{2}$"
                            onChange={e => {
                                setIsRate(true);
                                setIsMoney(false);
                                updateData('amount', '');
                                // 清除'數字'和'.'以外的符號
                                e.target.value = e.target.value.replace(
                                    /[^\d.]/g,
                                    ''
                                );
                                // 必須保證第一個為'數字'而不是'.'
                                e.target.value = e.target.value.replace(
                                    /^\./g,
                                    ''
                                );
                                // 必須保證格式為三位整數和零只能連續兩次
                                // e.target.value = e.target.value.replace(
                                //     /^[0-9]{4,}|^0{2,}/g,
                                //     ''
                                // );
                                // 保證只有出現一個'.'，沒有多個'.'
                                e.target.value = e.target.value.replace(
                                    /\.{2,}/g,
                                    '.'
                                );
                                // 保證'.'只出現一次，而不能出現兩次以上
                                e.target.value = e.target.value
                                    .replace('.', '$#$')
                                    .replace(/\./g, '')
                                    .replace('$#$', '.');
                                // 只能輸入兩位小數
                                // e.target.value = e.target.value.replace(
                                //     /^(-)*(\d+)\.(\d\d).*$/,
                                //     '$1$2.$3'
                                // );
                                const finalMRate = e.target.value;
                                updateData('mRate', finalMRate);
                            }}
                            placeholder={`${mRate ? '' : '請輸入維持率'}`}
                        />
                    </li>
                </div>
                <div className="totalbox text-end  px-md-2 py-3">
                    <div className="price">
                        {isMoney || isRate ? (
                            isMoney ? (
                                <div>
                                    <button
                                        type="button"
                                        className="btn_check btn rounded-pill text-white me-3 ps-3 mb-1"
                                        onClick={e => {
                                            setShowRate(true);
                                            if (
                                                parseInt(
                                                    removeNonNumeric(amount)
                                                ) % 1000
                                            ) {
                                                updateData(
                                                    'amount',
                                                    Math.floor(amount / 1000) *
                                                        1000
                                                );
                                            }
                                        }}
                                    >
                                        試算
                                    </button>
                                    <label className="text-black2 align-text-bottom fw-bolder">
                                        預估目標維持率
                                    </label>
                                    {showRate && amount !== '0' && !!amount ? (
                                        <b className="text-orange fit-3 ps-3">
                                            {parseInt(
                                                removeNonNumeric(amount)
                                            ) === borrowingAmount
                                                ? 0
                                                : Math.floor(eRate * 10000) /
                                                  100}
                                            <span>%</span>
                                        </b>
                                    ) : (
                                        <b className="text-danger ps-3">
                                            尚未輸入還款金額
                                        </b>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    <label className="text-black2 align-text-bottom fw-bolder">
                                        預估現金還款金額
                                    </label>
                                    {mRate ? (
                                        <b className="red fit-3 ps-3">
                                            <span>$</span>
                                            {addCommas(
                                                Math.ceil(money / 1000) * 1000
                                            )}
                                        </b>
                                    ) : (
                                        <b className="text-danger ps-3">
                                            尚未輸入維持率
                                        </b>
                                    )}
                                </div>
                            )
                        ) : (
                            ''
                        )}
                    </div>
                    {isMoney || isRate ? (
                        <a
                            className="clearcontent fs-12 text-black-50 text-decoration-underline cur-pointer"
                            onClick={() => {
                                reset({
                                    amount: '',
                                    mRate: '',
                                });
                            }}
                        >
                            清除計算
                        </a>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    );
};

export default observer(IsAmount);
